import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.StatusFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'status'
  facetName: 'status'
  humanize: true
  selectAll: true
  alias: 'Moderation Result'

  getAppliedValues: ->
    return @searchQuery.get('status')

  addFilter: (value) ->
    @searchQuery.addStatus(value)
